/* eslint tailwindcss/no-custom-classname: off */
interface Props {
  lang: 'ja' | 'en'
  className?: string
}
export const Language: React.FC<Props> = ({ lang, className }) => {
  return (
    <div className={`${className || ''} lvl lang ${lang}`}>
      {lang === 'ja' ? '日本語' : '英語'}
    </div>
  )
}
